/* eslint-disable */
import axios from 'axios';


export default {

    state : {
        userPays : [],
    },

   
    getters : {

        allUserPays(state) {
            return state.userPays;
        },

    },

    mutations: {
        setUserPays(state, data) {
            state.userPays = data;
        },
    },

    actions : {
        requestBill({dispatch, commit, rootState}, data) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
            return new Promise((resolve, reject)=> {
                axios.post('/requestBill', data)
                .then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })
            });
        },

        getUserPays({dispatch, commit, rootState}) {
            
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

            axios.get('/getUserPays') //Получаем оплаты
                .then(response => {
                    commit('setUserPays', response.data)                 
                })
                .catch(error => {
                    if ((error.response.status == 401)||(error.response.status == 500)) {
                        console.log(error);
                    }
                    else {
                        let t = error.response.status == 429 ? 15000 : 1500;  
                        if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                        setTimeout(()=>{        // повторная загрузка через секунду
                            dispatch('getUserPays');
                        }, t);
                    }
                    reject(error.response.status)
                });

        },
    }

}